import React from 'react'

const CustomSearchBtn = ({ handleSearch, extraStyle = null, isMobile, color = "customAccentBlue" }) => {
  return (
    <button
      type="button"
      className={`text-white ${isMobile ? 'text-xs' : 'text-sm'} px-8 py-2 dark:bg-customAccent dark:hover:bg-customAccent/80 dark:text-customWhite hover:bg-${color}/80 rounded-sm bg-${color} mb-1 ml-1 ${extraStyle}`}
      onClick={handleSearch}
    >
      Search
    </button>
  )
}

export default CustomSearchBtn;
